// eslint-disable-next-line import/prefer-default-export
export const ACTION_TYPE_LINK = 'MENU_LINK';
